export const hasPermissionOld = (module, action) => {
  const role = localStorage.getItem("userRole");
  const modules =
    JSON.parse(localStorage.getItem("userModule")) || [];

  const permissionKey = `${role}.${module}.${action}`;
  //console.log("Checking permission for:", permissionKey);
  return modules.includes(permissionKey);
};

export const hasPermission = (module, action) => {
  const role = localStorage.getItem("userRole");

  let modules = [];
  try {
    const storedModules = localStorage.getItem("userModule");
    modules = storedModules ? JSON.parse(storedModules) : [];
  } catch (err) {
    console.error("Invalid userModule in localStorage", err);
    return false;
  }

  if (!role || !module || !action) return false;

  // Normalize actions to array
  const actions = Array.isArray(action) ? action : [action];

  // Check ANY permission
  const hasAccess = actions.some(act => {
    const permissionKey = `${role}.${module}.${act}`;
    console.log("Checking permission for:", permissionKey);
    return modules.includes(permissionKey);
  });

  return hasAccess;
};
